"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ValidationResult_1 = require("./ValidationResult");
var getValidations_1 = require("./getValidations");
var fixAndMergeSchema_1 = require("./fixAndMergeSchema");
var validPropFunction_1 = require("./validPropFunction");
var schemaMethods_1 = require("../schemaMethods");
var validFunction_1 = require("./validFunction");
function wrapSchemaProps($schema, internal, type, props) {
    for (var _i = 0, props_1 = props; _i < props_1.length; _i++) {
        var field = props_1[_i];
        if (internal.schema[field] !== undefined) {
            if (typeof internal.schema[field] !== type) {
                wrapSchemaProp($schema, internal, field);
            }
            else {
                $schema[field] = internal.schema[field];
            }
        }
    }
}
exports.wrapSchemaProps = wrapSchemaProps;
function wrapSchemaProp($schema, internal, field) {
    var schema = internal.schema;
    internal.needsCalcArgs = true;
    var v = schema[field];
    delete $schema[field];
    // if (self.isSimpleField(v)) {
    // console.log(`create valid function`, field, v, internal.parent);
    if (schema.cache === undefined) {
        schema.cache = {};
    }
    var ff = schema.cache["schema_" + field];
    if (ff === undefined) {
        ff = validPropFunction_1.default(v);
        // console.log('calc func', ff.toString());
        schema.cache["schema_" + field] = ff;
    }
    Object.defineProperty($schema, field, {
        enumerable: true,
        get: function () {
            try {
                return ff.apply(internal.parent.$model, internal.calcargs);
            }
            catch (_a) {
                return undefined;
            }
        }
    });
}
exports.wrapSchemaProp = wrapSchemaProp;
function validateTable(schema, data, path, exitOnFirstError, parent, key, $external) {
    if (path === void 0) { path = ''; }
    if (exitOnFirstError === void 0) { exitOnFirstError = true; }
    var result = [];
    if (schema.minItems !== undefined) {
        if (data.length < schema.minItems) {
            var err = {
                validation: 'minItems',
                expected: schema.minItems,
                value: data.length,
                path: path
            };
            if (exitOnFirstError) {
                return err;
            }
            result.push(err);
        }
    }
    if (schema.maxItems !== undefined) {
        if (data.length > schema.maxItems) {
            var err = {
                validation: 'maxItems',
                expected: schema.maxItems,
                value: data.length,
                path: path
            };
            if (exitOnFirstError) {
                return err;
            }
            result.push(err);
        }
    }
    return exitOnFirstError ? null : result;
}
exports.validateTable = validateTable;
function validateField(schema, data, path, exitOnFirstError, parent, key, $external) {
    if (path === void 0) { path = ''; }
    if (exitOnFirstError === void 0) { exitOnFirstError = true; }
    var schemaIsNumber = false;
    var dataIsNumber = false;
    var result = [];
    var $schema = {};
    var internal = { schema: schema };
    var funcs = getValidations_1.getValidations(schema, schema, false);
    switch (schema.type) {
        case 'integer':
        case 'number':
        case 'money':
            wrapSchemaProps($schema, internal, 'number', [
                'minimum',
                'maximum',
                'exclusiveMaximum',
                'exclusiveMinimum',
                'precision'
            ]);
            break;
        case 'string':
            wrapSchemaProps($schema, internal, 'number', [
                'maxLength',
                'minLength',
                'minimum',
                'maximum',
                'exclusiveMaximum',
                'exclusiveMinimum'
            ]);
            break;
        case 'array':
            wrapSchemaProps($schema, internal, 'number', ['maxItems', 'minItems']);
            break;
    }
    if (schema.enum !== undefined) {
        if (!Array.isArray(schema.enum)) {
            wrapSchemaProp($schema, internal, 'enum');
        }
        else {
            $schema.enum = schema.enum;
        }
    }
    if (schema.required !== undefined &&
        schema.type !== 'object' &&
        (typeof schema.required === 'string' || typeof schema.required === 'boolean')) {
        schema.fieldRequired = schema.required;
    }
    wrapSchemaProps($schema, internal, 'boolean', ['fieldRequired']);
    var validFunc = null;
    if (schema.validFunc) {
        internal.needsCalcArgs = true;
        var tempFunc_1 = validFunction_1.default(schema, schema.validFunc, false, process.env.NODE_ENV === 'development' && schema.debug);
        validFunc = function (value) {
            var funcvalue = tempFunc_1.apply(internal.parent.$model, internal.calcargs);
            if (funcvalue === true || funcvalue === undefined) {
                return null;
            }
            if (funcvalue === false) {
                return 'validFunc';
            }
            return funcvalue;
        };
        funcs.push(validFunc);
    }
    var obj = {
        $key: key,
        $model: data,
        $parent: parent
    };
    if (parent === null) {
        obj.$root = obj;
    }
    else {
        obj.$root = parent.$root;
    }
    if (internal.needsCalcArgs) {
        var paramData = [obj.$root.$model, {}, {}, {}, $external, schemaMethods_1.default, obj];
        if (parent) {
            paramData[1] = parent.$model;
            if (parent.parent) {
                paramData[2] = parent.parent.$model;
                if (parent.parent.parent) {
                    paramData[3] = parent.parent.parent.$model;
                }
            }
        }
        internal.calcargs = paramData;
        internal.parent = parent;
    }
    // console.log(JSON.stringify(schema));
    if (schema.type === 'number' || schema.type === 'money') {
        schemaIsNumber = true;
        if (data !== undefined) {
            if (typeof data !== 'number') {
                // result.valid = false;
                var err = {
                    validation: 'type',
                    expected: schema.type,
                    value: typeof data,
                    path: path
                };
                if (exitOnFirstError) {
                    return err;
                }
                result.push(err);
            }
            else {
                dataIsNumber = true;
            }
        }
    }
    else if (schema.type === 'int' || schema.type === 'integer') {
        schemaIsNumber = true;
        if (data !== undefined) {
            if (typeof data !== 'number') {
                // result.valid = false;
                var err = {
                    validation: 'type',
                    expected: schema.type,
                    value: typeof data,
                    path: path
                };
                if (exitOnFirstError) {
                    return err;
                }
                result.push(err);
            }
            else {
                if (data % 1 !== 0) {
                    // result.valid = false;
                    var err = {
                        validation: 'type',
                        expected: schema.type,
                        value: 'float',
                        path: path
                    };
                    if (exitOnFirstError) {
                        return err;
                    }
                    result.push(err);
                }
                else {
                    dataIsNumber = true;
                }
            }
        }
    }
    if (schemaIsNumber) {
        if (dataIsNumber) {
            for (var _i = 0, funcs_1 = funcs; _i < funcs_1.length; _i++) {
                var func = funcs_1[_i];
                var res = func(data, $schema);
                if (res) {
                    var err = {
                        validation: res,
                        expected: schema[res],
                        value: data,
                        path: path
                    };
                    if (exitOnFirstError) {
                        return err;
                    }
                    result.push(err);
                }
            }
        }
    }
    else {
        if (schema.type === 'string') {
            if (data !== undefined) {
                if (data !== undefined && typeof data !== 'string') {
                    var err = {
                        validation: 'type',
                        expected: schema.type,
                        value: typeof data,
                        path: path
                    };
                    if (exitOnFirstError) {
                        return err;
                    }
                    result.push(err);
                }
                else {
                    for (var _a = 0, funcs_2 = funcs; _a < funcs_2.length; _a++) {
                        var func = funcs_2[_a];
                        var res = func(data, $schema);
                        if (res) {
                            var err = {
                                validation: res,
                                expected: schema[res],
                                value: data,
                                path: path
                            };
                            if (exitOnFirstError) {
                                return err;
                            }
                            result.push(err);
                        }
                    }
                }
            }
        }
        else if (schema.type === 'boolean') {
            if (data !== undefined) {
                if (data !== undefined && typeof data !== 'boolean') {
                    var err = {
                        validation: 'type',
                        expected: schema.type,
                        value: typeof data,
                        path: path
                    };
                    if (exitOnFirstError) {
                        return err;
                    }
                    result.push(err);
                }
                else {
                    for (var _b = 0, funcs_3 = funcs; _b < funcs_3.length; _b++) {
                        var func = funcs_3[_b];
                        var res = func(data, $schema);
                        if (res) {
                            var err = {
                                validation: res,
                                expected: schema[res],
                                value: data,
                                path: path
                            };
                            if (exitOnFirstError) {
                                return err;
                            }
                            result.push(err);
                        }
                    }
                }
            }
        }
        else if (schema.type === 'array') {
            if (data !== undefined) {
                if (data !== undefined && data !== null && !Array.isArray(data)) {
                    var err = {
                        validation: 'type',
                        expected: schema.type,
                        value: typeof data,
                        path: path
                    };
                    if (exitOnFirstError) {
                        return err;
                    }
                    result.push(err);
                }
                else {
                    for (var _c = 0, funcs_4 = funcs; _c < funcs_4.length; _c++) {
                        var func = funcs_4[_c];
                        var res = func(data, $schema);
                        if (res) {
                            var err = {
                                validation: res,
                                expected: schema[res],
                                value: data,
                                path: path
                            };
                            if (exitOnFirstError) {
                                return err;
                            }
                            result.push(err);
                        }
                    }
                }
            }
        }
    }
    return exitOnFirstError ? null : result;
}
exports.validateField = validateField;
function _validate(schema, data, path, exitOnFirstError, result, parent, key, $external) {
    var obj = {
        $key: key,
        $model: data,
        $parent: parent
    };
    if (parent === null) {
        obj.$root = obj;
    }
    else {
        obj.$root = parent.$root;
    }
    if (schema.type === 'object') {
        var required = schema.required || [];
        if (schema.properties) {
            for (var keyprop in schema.properties) {
                // for (let key of schema.$keys) {
                if (schema.properties.hasOwnProperty(keyprop)) {
                    var element = schema.properties[keyprop];
                    var value = data[keyprop];
                    if (required.indexOf(keyprop) > -1 && element.fieldRequired === undefined) {
                        element.fieldRequired = true;
                    }
                    /*
                              if (element.fieldRequired || required.indexOf(key) > -1) {
                                  if (value === undefined
                                      || (element.type === 'string' && !value)
                                      //|| (element.type === 'integer' && !value)
                                  ) {
                                      // result.valid = false;
                                      result.errors.push({
                                          validation: 'required',
                                          path: path === '' ? key : path + '.' + key
                                      });
                                      if (exitOnFirstError) {
                                          continue;
                                      }
                                  }
                              }
                              */
                    // if (value !== undefined) {
                    _validate(element, value, path === '' ? keyprop : path + '.' + keyprop, exitOnFirstError, result, obj, keyprop, $external);
                    // }
                }
            }
        }
    }
    else if (schema.type === 'array') {
        if (exitOnFirstError) {
            // const err = validateTable(schema, data, path, true, parent, key, external) as ValidationError;
            var err = validateField(schema, data, path, true, parent, key, external);
            if (err) {
                result.errors.push(err);
            }
        }
        else {
            // const errs = validateTable(schema, data, path, false, parent, key, external) as ValidationError[];
            var errs = validateField(schema, data, path, false, parent, key, external);
            if (errs.length) {
                result.errors = result.errors.concat(errs);
            }
        }
        // uniqueItems
        // contains
        var items = schema.items;
        if (items && data) {
            for (var i = 0; i < data.length; i++) {
                var subobj = {
                    $key: i,
                    $model: data[i],
                    $parent: obj,
                    $root: obj.$root
                };
                var res = _validate(items, data[i], path + '[' + i + ']', exitOnFirstError, result, subobj, i, $external);
            }
        }
    }
    else {
        if (exitOnFirstError) {
            var err = validateField(schema, data, path, true, parent, key, $external);
            if (err) {
                result.errors.push(err);
            }
        }
        else {
            var errs = validateField(schema, data, path, false, parent, key, $external);
            if (errs.length > 0) {
                result.errors = result.errors.concat(errs);
            }
        }
    }
}
/**
 * Sprawdza poprawnoc danych według schematu i zawartej w nim walidacji
 * @param data dane do sprawdzenia
 * @param schema gałąź schamtu, gdy pominięto to uzywa glownej
 * @param path sciezka startowa pola, przy pominięciu ustawia pustą
 */
function validate(schema, data, exitOnFirstError, path, $external) {
    if (exitOnFirstError === void 0) { exitOnFirstError = true; }
    if (path === void 0) { path = ''; }
    var result = new ValidationResult_1.default();
    if (schema.$parent === undefined) {
        if (Array.isArray(schema)) {
            schema = fixAndMergeSchema_1.default(schema);
        }
        else {
            schema = fixAndMergeSchema_1.default([schema]);
        }
    }
    _validate(schema, data, path || '', exitOnFirstError, result, null, null, $external);
    if (result.errors.length) {
        result.valid = false;
    }
    return result;
}
exports.default = validate;
//# sourceMappingURL=validate.js.map